import type {
    QuickCategoriesIdEmptyType,
    QuickCategoriesIdType,
    QuickCategoriesType,
} from './QuickCategoriesConfig';

export class QuickCategories {
    private categories: QuickCategoriesType[] = [];
    private currentId: QuickCategoriesIdType | QuickCategoriesIdEmptyType = '';

    constructor(quickCategoriesConfig: QuickCategoriesType[] = []) {
        let cfg = quickCategoriesConfig.map(category => ({ ...category }));
        cfg.forEach(category => {
            this.addCategory(category);
        });
    }

    getCategories() {
        return this.categories;
    }

    setCurrentId(id: QuickCategoriesIdType | QuickCategoriesIdEmptyType) {
        this.currentId = id;
    }

    getCurrentId(): QuickCategoriesIdType | QuickCategoriesIdEmptyType {
        return this.currentId;
    }

    addCategory(category: QuickCategoriesType) {
        if (!this.categories.find(cat => category.id === cat.id)) {
            this.categories.push(category);
        }
    }

    updateQuantity(id: QuickCategoriesIdType, quantity: number) {
        const category = this.categories.find(category => category.id === id);
        if (category) {
            category.quantity = quantity;
        }
    }

    updateAdhoc(id: QuickCategoriesIdType, adhoc: number) {
        const category = this.categories.find(category => category.id === id);
        if (category) {
            category.adhoc = adhoc;
        }
    }

    getAdhoc(id: QuickCategoriesIdType): number {
        const category = this.categories.find(category => category.id === id);
        return category?.adhoc ?? -1;
    }

    getQuantity(id: QuickCategoriesIdType): number {
        const category = this.categories.find(category => category.id === id);
        return category?.quantity ?? -1;
    }

    incrementQuantity(id: QuickCategoriesIdType, addition: number) {
        const category = this.categories.find(category => category.id === id);
        if (category) {
            category.quantity += addition;
        }
    }

    reset(id: QuickCategoriesIdType) {
        const category = this.categories.find(category => category.id === id);
        if (category) {
            category.quantity = 0;
            category.adhoc = 0;
        }
    }

    incrementAdhoc(id: QuickCategoriesIdType, addition: number) {
        const category = this.categories.find(category => category.id === id);
        if (category) {
            category.adhoc += addition;
        }
    }

    getColor(id: QuickCategoriesIdType): string {
        const category = this.categories.find(category => category.id === id);
        return category?.color ?? '#F00';
    }

    getBackgroundColor(id: QuickCategoriesIdType): string {
        const category = this.categories.find(category => category.id === id);
        return category?.backgroundColor ?? '#F00';
    }

    getTotalQuantity(): number {
        return this.categories.reduce((acc, category) => acc + category.quantity, 0);
    }
}
